var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        "ok-disabled": _vm.disableSubmit,
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "j-form-container",
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    slot: "detail",
                    model: _vm.model,
                    rules: _vm.validatorRules
                  },
                  slot: "detail"
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.unitCode"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "portalOrgCode"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["portal.unitCode"],
                                  maxLength: _vm.ml_code,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.portalOrgCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "portalOrgCode", $$v)
                                  },
                                  expression: "model.portalOrgCode"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.unitName"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "portalOrgName"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: { width: "85%" },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["portal.unitName"],
                                  maxLength: _vm.ml_name,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.portalOrgName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "portalOrgName", $$v)
                                  },
                                  expression: "model.portalOrgName"
                                }
                              }),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { left: "3%" },
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.languageModelOpen(
                                        "SysPortalOrg",
                                        "portalOrgName",
                                        _vm.portalOrgNameLanguages
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.language["common.language"])
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["ad.image"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "imgPath"
                              }
                            },
                            [
                              _c("j-image-upload", {
                                attrs: { disabled: _vm.disableSubmit },
                                model: {
                                  value: _vm.model.imgPath,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "imgPath", $$v)
                                  },
                                  expression: "model.imgPath"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.unitDesc"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "portalOrgDesc"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["portal.unitDesc"],
                                  maxLength: _vm.ml_desc,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.portalOrgDesc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "portalOrgDesc", $$v)
                                  },
                                  expression: "model.portalOrgDesc"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.unitStatus"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "status"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "radio",
                                  "trigger-change": true,
                                  dictCode: "sys_portal_up_down",
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "status", $$v)
                                  },
                                  expression: "model.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.unitSortNo"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "sortNo"
                              }
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["portal.unitSortNo"],
                                  min: 1,
                                  max: 999999,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.sortNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "sortNo", $$v)
                                  },
                                  expression: "model.sortNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["portal.unitApp"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "selectedApps"
                              }
                            },
                            [
                              _c("j-multi-select-tag", {
                                attrs: {
                                  options: _vm.appsOptions,
                                  disabled: _vm.disableSubmit,
                                  placeholder:
                                    _vm.language["common.pleaseChoose"] +
                                    _vm.language["portal.unitApp"]
                                },
                                model: {
                                  value: _vm.model.selectedApps,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "selectedApps", $$v)
                                  },
                                  expression: "model.selectedApps"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["basedata.remark"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "remark"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["basedata.remark"],
                                  maxLength: _vm.ml,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "remark", $$v)
                                  },
                                  expression: "model.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }